<ng-container *ngIf="params.value">
  <a
    *ngIf="href; else noLink"
    class="lum-ag-grid-cell--router-link"
    [href]="href"
    (click)="navigate($event)"
    [target]="target"
    >{{ value }}</a
  >
  <ng-template #noLink>{{ value }}</ng-template>
</ng-container>
